/* eslint-disable @typescript-eslint/camelcase */
import { PrintDataEntitas } from "@/domain/entities/Booking";
import { createI18n } from "vue-i18n";
import en from "@/i18n/locales/en";
import id from "@/i18n/locales/id";
import my from "@/i18n/locales/my";
import { headerSectionV3 } from "./sections-v3/header";
import { logoBlack } from "../constants/images";
import { originDestinationV3 } from "./sections-v3/origin";
import { ursaSlaV3 } from "./sections-v3/ursa-sla";
import { deliverySectionV3 } from "./sections-v3/delivery";
import { rightPanelV3 } from "./sections-v3/right-panel";
import { footerSectionV3 } from "./sections-v3/footer";
import { getWaterMark } from "./sections-v3/watermark";
import { TableProductsSectionV3 } from "./sections-v3/table-products-section";
import { renderBottomTerms } from "./sections-v3/footer/terms";
import { shiftX } from "./sections-v3/footer/utils";

export const newReceiptV3 = async (
  params: {
    doc: any;
    bookingType: string;
    accountType: string;
    data: PrintDataEntitas;
    pieceData: any;
    barcode: string;
    vendorRefCode: string;
    barcodeValue: string;
    vendorRefCodeValue: string;
    logo: string;
    shipmentId: string;
    startX: number;
    startY: number;
  },
  language = "id"
) => {
  const i18nInstance = createI18n({
    legacy: false,
    locale: language,
    fallbackLocale: "id",
    globalInjection: false,
    messages: {
      en,
      id,
      my
    }
  });
  const translate = i18nInstance.global.t;

  const logoProps = params.doc.getImageProperties(logoBlack);
  const logoAspectRatio = Number(logoProps?.height || 1) / Number(logoProps?.width || 1);

  await getWaterMark(params);
  await headerSectionV3(params, logoAspectRatio, translate);
  originDestinationV3(params, { startX: params.startX, startY: params.startY });
  ursaSlaV3(params, { startX: params.startX, startY: params.startY }, translate);
  rightPanelV3(params, translate);
  await deliverySectionV3(params, translate, language);
  if (params.data.sttProducts?.length) {
    TableProductsSectionV3(params, translate);
    renderBottomTerms({
      doc: params.doc,
      leftMargin: shiftX(params.startX + 4),
      rightMargin: shiftX(params.startX + 101),
      bottomTermsY: params.startY + 146,
      translate
    });
    return;
  }
  await footerSectionV3(params, logoAspectRatio, translate, language);
};
